import { render } from "./LeaveGroup.vue?vue&type=template&id=7d32cb90"
import script from "./LeaveGroup.vue?vue&type=script&lang=js"
export * from "./LeaveGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__